module.exports = __webpack_public_path__ + "img/img_tab_bar.4527136a.png";